<template functional>
  <router-link
    :class="data.staticClass"
    :to="{
      name: props.name,
      params: props.params,
      query: props.query,
      to: props.to,
    }"
    :exact="props.exact"
    :tag="props.tag"
    :target="props.newTab ? '_blank' : false">
    <slot/>
  </router-link>
</template>

<script>
export default {
  props: {
    name: String,
    to: String,
    params: {
      type: Object,
      default: () => {}
    },
    query: {
      type: Object,
      default: () => {}
    },
    exact: {
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: 'a',
    },
    newTab: {
      type: Boolean,
      default: false
    },
  }
}
</script>
